export default __webpack_public_path__ + "static/media/logoSeasideMobile.2687cc08.svg";